@if (documents && documentPermissions) {
    <document-manager-old
        [Documents]="documents"
        [permissions]="documentPermissions"
        (DocumentsChange)="onDocumentsChange($event)"
        [AllowAdd]="editAllowed"
        [AllowEdit]="editAllowed"
        [AllowDelete]="editAllowed"
        [DocumentTypeTargets]="documentTypeTargets"
    ></document-manager-old>
} @else {
    <div class="fancy-loader"></div>
}
